<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-row justify="center" align="center" class="py-4">
            <v-col class="d-flex justify-center">
                <div class="d-flex justify-center">
                    <v-btn
                        v-for="lineNumber in workOrderLineNumberTypes"
                        :key="lineNumber.type"
                        dark
                        color="bal-red"
                        class="btn-large px-2 mx-1"
                        style="min-width: 0"
                        @click.stop="handleLineNumberSelection(lineNumber.type)"
                    >
                        {{ lineNumber.text | t }}
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "work-order-line-number-select",
    data() {
        return {};
    },
    mounted() {
        const userRoles = this.user.work_roles || [];
        const userRole = this.user.role;

        const isLimited =
            userRole !== "superadmin" ||
            (!userRoles.includes("head_of_shift") &&
                !userRoles.includes("superadmin") &&
                userRoles.includes("operator"));

        if (isLimited) {
            this.handleLineNumberSelection("all");
        }
    },
    computed: {
        ...mapState(["user"]),
        ...mapState("WorkOrderStore", ["workOrderLineNumberTypes"]),
        PermissionsConstants() {
            return PermissionsConstants;
        },
    },
    methods: {
        ...mapMutations("WorkOrderStore", ["setSelectedLineNumberType"]),
        handleLineNumberSelection(type) {
            this.setSelectedLineNumberType(type);
            this.$router.push({
                name: "work-order-list",
                query: { lineNumber: type },
            });
        },
    },
};
</script>

<style scoped>
.btn-large {
    min-width: 5% !important;
    height: 200% !important;
    font-size: 16px;
}
</style>
